import { AxiosError } from 'axios';

type CycleConflictResponse = {
  code?: string;
  message?: string;
  conflicts?: {
    controllerName?: string;
    controllerSerialNumber?: string;
    channelNumber?: number;
    activeCycleNames?: string[];
    activeCycleContractNames?: (string | null)[];
  }[];
};

export type CycleConflictError = {
  message: string;
  conflicts: NonNullable<CycleConflictResponse['conflicts']>;
};

export const getCycleConflictError = (error: unknown): CycleConflictError | null => {
  if (!(error instanceof AxiosError)) {
    return null;
  }

  if (error.response?.status !== 409) {
    return null;
  }

  const data = error.response.data as CycleConflictResponse;

  if (data?.code !== 'CYCLE_CHANNELS_IN_ACTIVE_USE') {
    return null;
  }

  return {
    message: data.message || 'Selected channels are already assigned to active cycles.',
    conflicts: data.conflicts || [],
  };
};
